export default __webpack_public_path__ + "static/media/con_MOVG03.af7df9d8.jpg";